import { useTranslation } from 'react-i18next'

export default function Remarks({ remarks }) {
	const { t } = useTranslation()

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.remarks')}</h2>
			<p className="mt-4 whitespace-pre-line text-sm text-gray-700">
				{remarks || t('trainings.details.emptyRemarks')}
			</p>
		</div>
	)
}
